<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="reject")
    modal(title="Rejeitar solicitação" active @close="$router.back()")
      div(slot="modal-body")
        form-group(label="Qual o motivo da rejeição?" :validation="$v" field="description")
          textarea.form-input(v-model="$v.description.$model" rows="4")
      div(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.$invalid" :class="{ loading }") Rejeitar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import filiationRequests from '@/services/filiationRequests'

export default {
  data() {
    return { description: '', loading: false }
  },
  validations: {
    description: { required },
  },
  methods: {
    async reject() {
      try {
        this.loading = true
        const { description } = this
        await filiationRequests.reject(this.$route.params.id, { description })
        this.$router.replace({ name: 'filiations.requests.list' })
        this.$toaster.success('Filiação rejeitada')
      } catch (e) {
        this.$toaster.error(e.message)
        this.loading = false
      }
    },
  },
}
</script>
